module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-3.6de002b9.png";